module.exports = __webpack_public_path__ + "static/media/alipay.65fec401.png";